import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { Droppable, Draggable } from 'react-beautiful-dnd'

import { getStageElementsByTypes } from '../../../functions'

import TableRow from './table-row'

class TableGroup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDropdown: false
    }
  }

  matchGroupChildren(children, drumElements) {
    const onlyDrumElements = children.every(child => child.title !== undefined ? drumElements.includes(child.title) : true)
    let unusedDrumElements = [...drumElements]

    children.map(child => {
      unusedDrumElements = update(unusedDrumElements, {$splice: [[child.title, 1]]})

      return child.title !== undefined ? drumElements.includes(child.title) : true
    })

    return onlyDrumElements && unusedDrumElements.length > 0
  }

  addDefaultDrumSet(item, children, drumElements) {
    let items = []
    let position = 0

    drumElements.forEach((element, index) => {
      const elementExists = children.map(child => child.title).includes(element)

      if (!elementExists) {
        position += 1

        items = update(items, {$push: [
          {
            class: 'instrument',
            group: this.props.group,
            type: 'drums',
            title: element,
            position: children.length+position,
            parent: item.id
          }
        ]})
      }
    })

    this.props.createRiderItems(null, items)
  }

  refuseDefaultDrumSet(item, params) {
    params = !params ? update(params, {$set: {}}) : params

    this.props.editRiderItem({
      id: item.id,
      params: update(params, {
        $merge: {hideGroupInitialization: true}
      })
    })
  }

  renderDropdown(item, children) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showDropdown: false}, () => {
                this.props.addRiderItem({
                  class: "instrument",
                  position: children.length+1,
                  parent: item.id || null,
                  type: item.type,
                  indexes: [
                    this.props.rowIndex,
                    children.length
                  ]
                })
              })}>Add instrument to {item.title}</li>
              {/*<li onClick={() => this.setState({showDropdown: false})}>Change channel number</li>*/}
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.deleteRiderItem(item.id))}>Remove this instrument group</li>
            </ul>
          : null
        }
      </div>
    )
  }

  render() {
    const { view, columns, item, rowIndex, stageElements } = this.props
    const { children } = item
    let { params } = item

    const drumElements = ['Kick drum', 'Snare drum', 'Rack tom', 'Floor tom', 'OH L', 'OH R']
    const showGroupInitialization = this.matchGroupChildren(children, drumElements)
    const hideGroupInitialization = (params && params.hideGroupInitialization) || false

    const handleClassName = classnames({
      'table-group-handle': true,
      'table-group-handle--single': children.length <= 1
    })

    return (
      <Draggable key={rowIndex} draggableId={item.id} isDragDisabled={!view.editable} type="instrument">
        {(provided, snapshot) => (
          <div className="table-group">
            <div className="table-group--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle} >
              <div className={handleClassName} {...provided.dragHandleProps} tabIndex="-1">
                <span>{children.length > 1 ? item.title : 'Drums'}</span>
              </div>

              {
                view.editable
                ? this.renderDropdown(item, children)
                : null
              }

              <Droppable droppableId={item.id} type={this.props.dragDropType}>
                {(provided, snapshot) => (
                  <div className="table-group--droppable"
                    ref={provided.innerRef} >
                    {
                      children.length > 0
                      ? children.map((child, index) => {
                          if (child.class.includes('instrument')) {
                            return (
                              <TableRow key={index}
                                view={view}
                                dragDropType={this.props.dragDropType}
                                group={this.props.group}
                                columns={columns}
                                item={child}
                                rowIndex={index}
                                parentItem={item}
                                parentRowIndex={rowIndex}
                                paging={this.props.paging}
                                itemGroups={this.props.itemGroups}
                                changeFocus={this.props.changeFocus}
                                addRiderItem={(item) => this.props.addRiderItem({...item, type: child.type})}
                                removeRiderItem={this.props.removeRiderItem}
                                createRiderItem={this.props.createRiderItem}
                                editRiderItem={this.props.editRiderItem}
                                deleteRiderItem={this.props.deleteRiderItem}
                                stageElements={this.props.stageElements}
                                options={stageElements.isFetching !== true ? [] : undefined}
                                categories={getStageElementsByTypes(['drums'], stageElements.groups && stageElements.groups.instrument && stageElements.groups.instrument.groups)}
                                createStageElement={this.props.createStageElement}
                                getSearchResults={this.props.getSearchResults} />
                            )
                          } else {
                            return false
                          }
                        })
                      : showGroupInitialization && !hideGroupInitialization
                        ? <div className="table-row table-row--empty">
                            <p className="group-initialization">
                              {`You have created a ${item.title}. Would you like us to set up the default drum set?`}

                              <button className="button--success" onClick={() => this.addDefaultDrumSet(item, children, drumElements)}>Set up</button>
                              <button className="button--default" onClick={() => this.refuseDefaultDrumSet(item, params)}>No thanks</button>
                            </p>
                          </div>
                        : <div className="table-row table-row--empty" onClick={() => {
                            this.props.addRiderItem({
                              class: "instrument",
                              position: children.length+1,
                              parent: item.id || null,
                              type: item.type,
                              indexes: [
                                this.props.rowIndex,
                                children.length
                              ]
                            })
                          }}>
                            <p>Start by adding your <a>first drum element</a>.</p>
                          </div>
                    }

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>

            {provided.placeholder}

            {/*
              children.length > 0
              ? <button className="table--add-button button--link" onClick={() => {
                  this.props.addRiderItem({
                    class: "instrument",
                    position: children.length+1,
                    parent: item.id || null,
                    type: item.type,
                    indexes: [
                      this.props.rowIndex,
                      children.length
                    ]
                  })
                }}>
                  Insert instrument to {item.title}
                </button>
              : null
            */}
          </div>
        )}
      </Draggable>
    )
  }
}

TableGroup.propTypes = {
  view: PropTypes.object,
  dragDropType: PropTypes.string,
  group: PropTypes.string,
  columns: PropTypes.array,
  item: PropTypes.object,
  rowIndex: PropTypes.number,
  paging: PropTypes.object,
  itemGroups: PropTypes.array,
  changeFocus: PropTypes.func,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func
}

TableGroup.defaultProps = {
  view: {},
  dragDropType: '',
  group: '',
  columns: [],
  item: {},
  rowIndex: undefined,
  paging: {},
  itemGroups: [],
  changeFocus: function() {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  createStageElement: function() {},
  getSearchResults: function() {}
}

export default TableGroup



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input-table/table-group.js